'use client';

import { __awaiter, __generator, __assign } from '../../../_virtual/_tslib.js';
import React__default from 'react';
import { useTranslate } from '../../../Contexts/translator/index.js';
import Col from '../../../LayoutSystem/Col.js';
import Row from '../../../LayoutSystem/Row.js';
import Typography from '../../../Typography/index.js';
import Form from '../../../Form/index.js';
import { SkillField } from './SkillField.js';
import { useOnBoarding } from '../../context/index.js';
import { updateBasicInfo } from '../../../services/resumes/index.js';
import { Title } from '../Title.js';

var Skills = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), formResumeInfo = _a.formResumeInfo, setFormResumeInfo = _a.setFormResumeInfo, setIsLoading = _a.setIsLoading, baseMsUrl = _a.baseMsUrl, accessToken = _a.accessToken, lang = _a.lang;
    var handleUploadResumeInfo = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var body, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!values)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = __assign(__assign({}, values), { salary: Number(values.salary), currentSalary: Number(values.currentSalary) });
                    return [4 /*yield*/, updateBasicInfo(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken !== null && accessToken !== void 0 ? accessToken : '', body, lang)];
                case 2:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.meta.code) === 200) {
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setIsLoading(false);
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement(Form, { initialValues: formResumeInfo, onSubmit: function (values) { return handleUploadResumeInfo(values); }, getCurrentValues: function (values) {
            setFormResumeInfo(values);
        } },
        React__default.createElement(Row, { gutter: [16, 24] },
            React__default.createElement(Col, null,
                React__default.createElement(Title, { title: t('Skill'), subTitle: t("This information plays a key role in introducing you to employers, and it's editable at any time.") })),
            React__default.createElement(Col, null,
                React__default.createElement(Typography, { variant: 'label', name: 'title', size: 'large' }, t('Skills'))),
            React__default.createElement(Form.Item, { name: 'skills', watch: ['jobTitle'] }, function (field) {
                return (React__default.createElement(Col, null,
                    React__default.createElement(SkillField, { field: field })));
            }))));
};

export { Skills as default };
//# sourceMappingURL=index.js.map
